import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { loadSettings, getAlertLvl, epochToHumanReadableTS } from '../components/Functions'
import LoadingOverlay from 'react-loading-overlay-ts';
import MuiDialogAlert from '../components/MuiDialogAlert';

import axios from 'axios';


const Overview = () => {
    
    let navigate = useNavigate();
    const alerts_seq = [
        "alert100","alert75","alert_normal","alert_empty"
    ]

    let tmp_alerts_total = {}

    const [binData, setBinData] = useState({})
    const [alertsTotal, setAlertsTotal] = useState({})
    const [loadingActive, setLoadingActive] = useState(false);
    const [initLoad, setInitLoad] = useState(false)
    const [pageLoaded, setPageLoaded] = useState(false)

    const [settings, setSettings] = useState({
        "color_codes": {},
        "map": {},
        "alerts": []
    })

    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalHtml, setModalHtml] = useState("");
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    useEffect(() => {

        const getSettings = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getSettings";
                console.log(`URL: ${url}`);
                const response = await axios.get(url,{
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });
                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }
                console.log(loadSettings(response.data));

                // Set the retrieved data to the state
                setSettings(loadSettings(response.data));
                setInitLoad(true)
                console.log("Set Setting finished")

            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load settings data")
                setShowModal(true)
            }
        };

        setLoadingActive(true);
        getSettings()
        setLoadingActive(false);
    }, [])


    useEffect(() => {

        const getDevicesData = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevicesData";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }

                console.log(response.data);
                // Set the retrieved data to the state

                let return_data = response.data
                let alert_grps = {}

                // init empty json with alert types
                for (let index = 0; index < alerts_seq.length; index++) {
                    alert_grps[alerts_seq[index]] = [];
                    tmp_alerts_total[alerts_seq[index]] = 0;
                }

                for (let index = 0; index < return_data.length; index++) {
                    const data = return_data[index];
                    let tmp_json = {}

                    tmp_json.device_id = data.device_id
                    tmp_json.location = data.settings.description

                    tmp_json.vol_percent = data.status.latest_transaction.VOLUME.vol_percent
                    tmp_json.vol_last_update = epochToHumanReadableTS(data.status.latest_transaction.VOLUME.vol_update_epoch)
                    
                    let alert_lvl = getAlertLvl(tmp_json.vol_percent, settings.alerts)
                    alert_grps[alert_lvl.alert_type].push(tmp_json)
                    tmp_alerts_total[alert_lvl.alert_type]++;
                }

                setBinData(alert_grps)
                setAlertsTotal(tmp_alerts_total)
                setPageLoaded(true)
                

            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load sensor data")
                setShowModal(true)            
            }
        };

        if (initLoad) {      
            setLoadingActive(true);
            getDevicesData()
            setLoadingActive(false);
        }

    }, [settings])

    return (
        <main>
            <div align="left" style={{ height: "100%" }}>
            <LoadingOverlay
                active={loadingActive}
                spinner
                text="Loading ..."
                className="spinner_div"
            >

            {
                pageLoaded &&
                <div>
                    <div className="container">
                        <div className='page_title'>Overview</div>     
                        <div className="row">
                            {
                                alerts_seq.map(alert => {
                                console.log(alert)
                                console.log(settings)
                                        
                                let alert_setting = settings.alerts[alert];
                                let backgroundColor = alert_setting.color_code ?? ""

                                return (
                                    <div className="col-md-6">
                                        <div className='overview_alert_header' style={{ backgroundColor: backgroundColor }}>
                                            <table height='100%' width='100%'>
                                                <tbody>
                                                    <tr>
                                                        <td align='left' className='overview_alert_header_description'>{alert_setting.description}</td>
                                                        <td align='right' width="80px" className='overview_alert_header_qty'>{alertsTotal[alert]}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        {
                                            binData[alert].map(bin => {
                                                let vol_percent = Number(bin.vol_percent).toFixed(0)
                                                if (vol_percent > 100) {
                                                    vol_percent = 100
                                                }

                                                return (
                                                    <div className='overview_data_container'>
                                                        <table width="100%">
                                                            <tbody>
                                                                <tr>
                                                                    <td align='left'>
                                                                        <div className='overview_data' style={{ fontSize: "24px", fontWeight: "900" }}>{bin.location}</div>
                                                                        <div className='overview_data' style={{ fontSize: "16px", fontWeight: "300" }}><b>Last Update:</b> {bin.vol_last_update}</div>
                                                                    </td>
                                                                    <td align='right' className='overview_data' style={{ fontSize: "32px", fontWeight: "900" }}>
                                                                        {vol_percent}%
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )
                                            })
                                        }
                                        <div style={{height: "30px"}}></div>
                                    </div>
                                )
                            })
                        }

                        </div>
                    </div>

                </div>
            }

                    <MuiDialogAlert
                        showModal={showModal}
                        handleClose={handleClose}
                        html={modalHtml}
                        bodyContent={modalBody}
                        title={modalHeader}
                        bodyClass="whitespace"
                    />
            
            </LoadingOverlay>
            </div>

        </main>

    )
}


export default Overview